"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slotData.form.label': 'Label',
    'slotData.form.value': 'Value',
    'slotData.form.type': 'Type',
};
